exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".text-info{padding:0 30px;margin-top:20px;font-size:15px;letter-spacing:1px;color:#565151}.default-btn-back{border-radius:4px!important;background-color:#aab5bc;padding:7px 35px;font-weight:600;text-align:center;color:#fff;border:none;display:block;margin:0 0 0 auto}.default-btn-back:active,.default-btn-back:focus,.default-btn-back:hover{background-color:#7b7878;color:#fff;text-decoration:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-158982a4","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/views/components/modalDisapproved.vue
// module id = 914
// module chunks = 0